/*= ========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== */
const actions = {

  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu
  updateVerticalNavMenuWidth({ commit }, width) {
    commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width);
  },

  // /////////////////////////////////////////////
  // UI
  // /////////////////////////////////////////////

  toggleContentOverlay({ commit }) {
    commit('TOGGLE_CONTENT_OVERLAY');
  },
  updateTheme({ commit }, val) {
    commit('UPDATE_THEME', val);
  },

  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  updateUserRole({ dispatch }, payload) {
    // Change client side
    payload.aclChangeRole(payload.userRole);

    // Make API call to server for changing role

  },
  updatePageTitle({ commit }, title) {
    commit('UPDATE_PAGE_TITLE', title);
  },
  updateBreadcrumb({ state, commit }, { to, from }) {
    const isDocPage = to.name && to.name.startsWith('documentation');
    if (isDocPage) {
      // The documentation components handle their own breadcrumbs
      // because the titles are dynamic and loaded from the state.
      return;
    }

    if (to.meta.breadcrumb) {
      commit('SET_BREADCRUMB', to.meta.breadcrumb);
      return;
    }

    const toItem = {
      title: to.meta.pageTitle,
      i18n: to.meta.i18nPageTitle || 2,
      fullPath: to.fullPath,
    };

    if (toItem.title) {
      commit('SET_BREADCRUMB', [toItem]);
    } else {
      commit('SET_BREADCRUMB', []);
    }
  },
  updateLastBreadcrumbItemTitle({ state, commit }, title) {
    if (title) {
      commit('UPDATE_BREADCRUMB_ITEM_TITLE', {
        index: state.breadcrumb.length - 1,
        title,
      });
    }
  },
  resetBreadcrumb({ commit }) {
    commit('SET_BREADCRUMB', []);
  },
  updateNavigationHistory({ commit }, { to }) {
    const historyItem = {
      title: to.meta.pageTitle,
      i18n: to.meta.i18nPageTitle || 2,
      fullPath: to.fullPath,
    };
    if (historyItem.title) {
      commit('ADD_TO_NAVIGATION_HISTORY', historyItem);
    }
  },
  updateLatestHistoryItemTitle({ commit }, title) {
    commit('UPDATE_LATEST_HISTORY_ITEM_TITLE', title);
  },
};

export default actions;
